import React, { useState, useEffect } from 'react';
import HeroImg from '../../Assets/images/Frame 133652.png';
import { useNavigate } from 'react-router-dom';
import LoanTypes from '../Service/LoanTypes';
import HowWeWorks from '../HowWeWorks/HowWeWorks';
import DownloadmApp from '../Download/DownloadmApp';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import StayConnected from '../Contact/StayConnected';

const Hero = () => {
  const navigate = useNavigate();
  const handleLoginClick = () => navigate('/login');
  return (
    <>
      <div id="hero" className="w-full bg-gray-100 mt-20 2xl:mt-32 h-screen">
        <div className=" container mx-auto lg:px-0 px-2 lg:py-20 py-20 flex flex-col lg:flex-row items-center justify-between md:mb-0 -mb-6 ">
          {/* Left Section: Text and Button */}
          <div className="text-center xl:text-left lg:w-1/3 md:mb-4 mb-0 md:ml-16 lg:mb-0 md:-mt-0 ">
            <h1 className="text-2xl md:text-4xl 2xl:text-6xl text-gray-800 2xl:mb-10 md:mb-5 mb-2 heading">
              Empowering Your Financial Future - Access UPAS/LC with Ease.
            </h1>
            <p className="text-gray-700 text-xs md:text-lg md:mb-10 mb-8 font-semibold">
              Simplifying UPAS/LC Applications for Customers, Streamlining
              Approvals for Banks.
            </p>
            <button
              className=" text-headerBtn px-3 md:px-6 md:py-3 py-1 rounded-3xl border-2 border-headerBtn hover:bg-headerBtn hover:text-gray-50 text-sm md:text-sm 2xl:text-lg md:mb-0 mb-10 heading"
              onClick={handleLoginClick}
            >
              Apply For UPAS/LC
            </button>
          </div>

          {/* Right Section: Image */}
          <div className=" flex justify-end">
            <img
              src={HeroImg}
              alt="Hero Image"
              className="w-full md:w-4/5 2xl:w-full h-auto"
            />
          </div>
        </div>
      </div>

      <LoanTypes />
      <HowWeWorks />
      <StayConnected />
      <DownloadmApp />
      <Contact />
    </>
  );
};

export default Hero;
